import btnStyle from '@/components/Shares/Button.module.css';
import { useModalAction } from '@/providers/ModalActionProvider';
import { useLingui } from '@lingui/react';
import { Button, type ButtonProps } from '@mantine/core';
import { Icons } from '../Shares/Icons';
export const BunkerStartButton: React.FC<ButtonProps> = ({
  ...props
}) => {
  const {
    i18n
  } = useLingui();
  const {
    setOpenModal
  } = useModalAction();
  return <Button {...props} fz={13} fullWidth tt="uppercase" classNames={btnStyle} onClick={() => setOpenModal(null)} leftSection={<Icons className="icon-pr-line-log-in" fontSize={25} />}>
      {i18n._('Start Playing')}
    </Button>;
};